<script setup>
    import { computed, defineProps } from "vue"
    import { usePersonnelStore } from "~/stores"

    // Props
    const props = defineProps({
        color: {
            default: "primary",
        },
        personnel_id: {
            required: false,
        },
        avatar_size: {
            default: 40,
        },
        active: {
            default: false,
        },
    })

    const personnelStore = usePersonnelStore()

    const computedStyle = computed(() => {
        return props.active ? "outline: 5px solid red" : ""
    })

    const userData = computed(() => {
        if (Array.isArray(props.personnel_id)) {
            if (props.personnel_id.length === 1) {
                return personnelStore.itemById[props.personnel_id[0]]
            } else {
                return {
                    INITIALES: props.personnel_id.length,
                }
            }
        }

        return personnelStore.itemById[props.personnel_id]
    })

    const avatarSize = props.avatar_size
</script>

<template>
    <v-avatar :color="color" :size="avatarSize" :style="computedStyle">
        <v-icon v-if="!userData" icon="mdi-account-circle" olor="white" />
        <v-img v-else-if="userData?.PHOTO" :src="userData?.PHOTO" />
        <p v-else>
            {{ userData?.INITIALES ?? "?" }}
        </p>
    </v-avatar>
</template>
